<template>
	<div
		:class="[
			'nqtc-container',
			{ 'disabled-container': disabledAnswerDetails },
		]"
	>
		<div class="selector-container"
			:style="`color:${$appColors.info}`"
		>
			<label :style="`color:${$appColors.info}`">
				Modo
				<multi-selector
					label="Modo"
					reference="nqtc-multiselect"
					class="mode"
					prop="title"
					:options="types"
					:value="selected"
					@input="selecting"
				/>
			</label>
		</div>
		<form>
			<div>
				<answer-form/>
			</div>
		</form>
		<div :style="`border-top:1px solid ${$appColors.gray}`"
			class="no-use"
		>
			<v-checkbox
				hide-details
				class="question-check"
				label="Agregar No Aplica"
				color="success"
				v-model="noUse"
				@change="setNoUse"
			></v-checkbox>
		</div>
	</div>
</template>
<script>
import multiSelector from '@/components/shared/multi-selector';
import answerForm from '@/components/configuration/answer/answer-form';
import { mapGetters } from 'vuex';

function selecting({ selected }) {
	this.selected = selected;
}

function setNoUse() {
	this.$store.dispatch('answer/setFlagNoUse', this.noUse);
}

function data() {
	return {
		selected: [{ id: 1, title: 'Cuantitativo' }],
		types: [
			{ id: 1, title: 'Cuantitativo' },
		],
		noUse: false,
	};
}

export default {
	name: 'new-answer-type-config',
	components: {
		multiSelector,
		answerForm,
	},
	computed: {
		...mapGetters('answer', {
			disabledAnswerDetails: 'invalidAnswer',
		}),
	},
	data,
	methods: {
		selecting,
		setNoUse,
	},
};
</script>
<style lang="scss" scoped>
.nqtc-container {
	height: inherit;

	.selector-container {
		padding: 6px 20px 18px;

		label {
			font-size: size(small);
	
			.mode {
				width: 50%;
			}
		}
	}

}
.disabled-container {
	opacity: 0.3;
}

.no-use {
	margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/answer/new-answer-type-config.vue